export const safeParseFloat = (value: string | null | undefined): number | null => {
  if (!value) {
    return null;
  }

  const cleanedValue = value.replace(/,/g, "").trim();
  // ast-grep-ignore: no-unsafe-number-parsing
  const parsed = parseFloat(cleanedValue);
  if (isNaN(parsed)) {
    return null;
  }

  return parsed;
};

export const safeParseInt = (value: string | null | undefined): number | null => {
  if (!value) {
    return null;
  }

  const cleanedValue = value.replace(/,/g, "").trim();
  // ast-grep-ignore: no-unsafe-number-parsing
  const parsed = parseInt(cleanedValue);
  if (isNaN(parsed)) {
    return null;
  }

  return parsed;
};
